<template>
  <ul class="tree">
    <AudioFormTreeNode
      @item-drag-start="dragStart"
      @item-drag-end="dragEnd"
      @item-drop="drop"
      :drag-data="dragData"
      :tree="formTree"
      :key="formTree.root.intKey"
      :node.sync="formTree.root"
      :parent="null"></AudioFormTreeNode>
  </ul>
</template>

<script>
  import AudioFormTreeNode from "./AudioFormTreeNode.vue";
  export default {
    components: { AudioFormTreeNode },
    props: {
      formTree: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        currentlyDraggedNode: null,
        dropTargetNode: null,
        dragging: false,
      };
    },
    computed: {
      dragData() {
        return {
          currentlyDraggedNode: this.currentlyDraggedNode,
          dropTargetNode: this.dropTargetNode,
          dragging: this.dragging,
        };
      },
    },
    methods: {
      dragStart(node) {
        this.dragging = true;
        this.currentlyDraggedNode = node;
      },
      dragEnd() {
        this.dragging = false;
        this.currentlyDraggedNode = null;
      },
      drop(node) {
        this.dropTargetNode = node;
        this.formTree.copyNode(this.currentlyDraggedNode, this.dropTargetNode);
        this.dragging = false;
      },
    },
  };
</script>

<style lang="scss">
  @import "@/@core/preset/preset/shortcodes.scss";
</style>
